export default "__VITE_ASSET__BkGoXijH__"